export const queryKeys = {
  properties: {
    all: ['properties'] as const,
    assigned: (
      accountId: string,
      teamMemberId: string,
      siteType: string,
    ) => ['properties', 'assigned', accountId, teamMemberId, siteType] as const,
    account: (accountId: string) => ['properties', 'account', accountId] as const,
    unassigned: (accountId: string, teamMemberId: string) => (
      ['properties', 'unassigned', accountId, teamMemberId] as const
    ),
  },
  team: {
    all: ['team'] as const,
    members: (accountId: string) => ['team', 'members', accountId] as const,
    member: (accountId: string, teamMemberId: string) => (
      ['team', 'member', accountId, teamMemberId] as const
    ),
  },
  clusters: {
    all: ['clusters'] as const,
    list: (accountId: string) => ['clusters', 'list', accountId] as const,
  },
  brands: {
    all: ['brands'] as const,
    list: (accountId: string) => ['brands', 'list', accountId] as const,
  },
  pages: {
    all: ['pages'] as const,
    list: (accountId: string) => ['pages', 'list', accountId] as const,
  },
};

export const PERSISTED_QUERY_ROOTS = new Set([
  'properties',
  'team',
  'clusters',
  'brands',
  'pages',
]);
